/* =========================================================================
   REYKVÖRN — shared behaviour for all rk-* sections
   Currently: reveal-on-scroll. Self-guards against running twice even though
   the file may be referenced by several sections on one page.
   ========================================================================= */
(function () {
  if (window.__rkBaseInit) return;
  window.__rkBaseInit = true;

  var supportsIO = 'IntersectionObserver' in window;
  var io = supportsIO
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('rk-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      )
    : null;

  function bindReveals(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.rk-reveal:not(.rk-in)');
    for (var i = 0; i < els.length; i++) {
      if (io) {
        io.observe(els[i]);
      } else {
        els[i].classList.add('rk-in');
      }
    }
  }

  // Expose so sections added live in the theme editor can re-scan themselves.
  window.rkBindReveals = bindReveals;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindReveals(document); });
  } else {
    bindReveals(document);
  }

  // Theme editor: re-bind reveals inside a freshly loaded section.
  document.addEventListener('shopify:section:load', function (event) {
    bindReveals(event.target);
  });
})();
